import {NgModule} from "@angular/core";
import { FormsModule } from "@angular/forms";
import {CommonModule} from "@angular/common";
import {LibraryComponent} from "./library.component";
import {AssignmentService} from "../services/assignment/assignment.service";
import {CurrentSelectionComponent} from "./current.selection.component";
import {LibraryService} from "../services/library/library.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { FeatureFlagPipeModule } from "../feature-flag/feature-flag.module";

@NgModule({
    bootstrap:      [
        LibraryComponent
    ],
    providers: [
        AssignmentService,
        LibraryService
    ],
    imports: [
        FormsModule,
        NgSelectModule,
        CommonModule,
        FeatureFlagPipeModule
    ],
    declarations: [
        LibraryComponent,
        CurrentSelectionComponent
    ]

})
export class LibraryModule {}
